import { getColor, tooltipFormatter } from '@/helpers/utils';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { Card, Dropdown, Table } from 'react-bootstrap';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import FalconLink from '@/components/common/FalconLink';
import TableRow from './session-by-browser/TableRow';
import Flex from '@/components/common/Flex';
import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { spamScoreVariant } from '@/helpers/spamScoreVariant';
import { useBacklinkSectionHref } from '../utils/useBacklinkSectionHref';
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent
]);
const MazScore = ({ data: result, noMore = false }: Record<string, any>) => {
  const bars = Object.keys(result?.spam_score);

  const data = Object.values(result?.spam_score).map((score, i) => ({
    value: score,
    itemStyle: {
      color:
        i < 3
          ? getColor('success')
          : i < 6
            ? getColor('warning')
            : getColor('danger')
    }
  }));

  
  const getOption = () => ({
    textStyle: {
      fontFamily: 'dana'
    },
    tooltip: {
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('gray-1100') },
      borderWidth: 1,
      formatter: tooltipFormatter,
      transitionDuration: 0,
      axisPointer: {
        type: 'none'
      }
    },
    xAxis: {
      type: 'category',
      data: bars,
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisTick: { show: false },
      axisLabel: {
        color: getColor('gray-400'),
        formatter: (value: string) => value,
        margin: 15
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show: true,
        color: getColor('gray-400'),
        margin: 15
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-200')
        }
      },
      axisTick: { show: false },
      axisLine: { show: false }
    },
    series: [
      {
        type: 'bar',
        name: 'Total',
        data,
        lineStyle: { color: getColor('primary') },
        itemStyle: {
          color: getColor('primary'),
          borderRadius: [3, 3, 0, 0]
        },
        showSymbol: false,
        symbol: 'circle',
        smooth: false,
        emphasis: {
          scale: true
        }
      }
    ],
    grid: { right: '3%', left: '10%', bottom: '10%', top: '5%' }
  });
  const cardRef = useRef<HTMLDivElement | null>(null);
  const chartRef = useRef<ReactEChartsCore | null>(null);
  const moreHref = useBacklinkSectionHref('/backlink/spam-domain');

  return (
    <Card className="h-100" ref={cardRef}>
      <FalconCardHeader
        title={
          <div>
            توزیع اسپم اسکور Moz دامنه‌ها (بازه‌های ۱۰تایی)
            <HelpTooltip html="واحد شمارش: دامنه‌های ارجاع‌دهنده. در «بازه‌های ۱۰‌تایی اسپم»، تعداد دامنه‌ها در هر بازهٔ ۱۰ امتیازی نمایش داده می‌شود. در «تجمیع شده مشابه‌ها»، بازه‌ها در سه گروه سالم (۰ تا ۳۰)، کم‌خطر (۳۱ تا ۶۰) و خطرناک (۶۱ تا ۱۰۰) تجمیع می‌شوند." />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={
          <Dropdown
            align="end"
            className="btn-reveal-trigger d-inline-block me-0"
          >
            <Dropdown.Toggle
              className="text-600 btn-reveal"
              split
              variant="reveal"
              size="sm"
            >
              <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="border py-0">
              <Dropdown.Item
                onClick={() => {
                  // var img = new Image();
                  // img.src = chartRef.current.echarts.getDataURL({
                  //   pixelRatio: 2,
                  //   backgroundColor: '#fff'
                  // });
                }}
                className="link-600 fs--1 d-flex align-items-center gap-1 py-1"
              >
                ذخیره تصویر
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  cardRef.current?.requestFullscreen();
                }}
                className="link-600 fs--1 d-flex align-items-center gap-1 py-1"
              >
                تمام صفحه
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        }
      />
      <Card.Body
        as={Flex}
        direction="column"
        justifyContent="between"
        className="py-0"
      >
        <ReactEChartsCore
          ref={chartRef}
          echarts={echarts}
          option={getOption()}
          style={{ height: 250 }}
        />
        <div style={{ maxHeight: 400, overflow: 'auto' }}>
          <Table size="sm" className="mb-0">
            <thead className="">
              <tr>
                <td className="py-3">
                  <Flex alignItems="center">
                    <h6 className="text-600 mb-0 ms-2"></h6>
                  </Flex>
                </td>
                <td className="py-3">
                  <Flex alignItems="center">
                    <h6 className={`fw-bold mb-0 text-secondary text-400`}>
                      درصد
                    </h6>
                  </Flex>
                </td>
                <td className="py-3">
                  <Flex alignItems="center" justifyContent="end">
                    <h6 className="fw-bold mb-0 text-secondary  text-400">
                      تعداد
                    </h6>
                  </Flex>
                </td>
              </tr>
            </thead>
            <tbody>
              {result?.domain_data
                ?.map(
                  (item: {
                    percentage: number;
                    value: number;
                    name: string;
                  }) => ({
                  color: spamScoreVariant(item.percentage),
                  percentage: item.percentage,
                  count: item.value,
                  label: item.name
                  })
                )
                .map(
                  (item: {
                    color: string;
                    percentage: number;
                    count: number;
                    label: string;
                  }) => (
                  <TableRow key={item.label} data={item} />
                  )
                )}
            </tbody>
          </Table>
        </div>
      </Card.Body>

      {!noMore && (
        <Card.Footer className="bg-body-tertiary text-end py-2">
          <FalconLink
            to={moreHref}
            title="بیشتر"
            className="px-0 fw-medium"
          />
        </Card.Footer>
      )}
    </Card>
  );
};
export default MazScore;
